import { jsx as _jsx } from "react/jsx-runtime";
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
const ProductInfo = props => {
    const productInfoVariable = `<script type="text/javascript">var productInfo = ${JSON.stringify(props)}</script>`;
    return _jsx(HtmlInclude, { htmlFragment: productInfoVariable });
};
export default ProductInfo;
